import {isNaN} from 'lodash';
import moment from 'moment';

import {pad} from './appHelper';

// eslint-disable-next-line import/prefer-default-export
export const formatDate = (dateTime, format) => moment(new Date(dateTime)).local().format(format);

/**
 * @param {Date} date
 * @param {Number} numberOfDay
 * @returns {Date}
 */
export const DateAddDay = (date, numberOfDay) => new Date(date.getTime() + numberOfDay * 86400000);

/**
 * @param {Date} date
 * @param {Number} numberOfDay
 * @returns {Date}
 */
export const DateSubtractDay = (date, numberOfDay) => new Date(date.getTime() - numberOfDay * 86400000);

/**
 * Parse Date into Year, Month, and Day
 * @param {Date} date
 * @param {String} separator default value is '/'
 * @returns {String}
 * @example
 * DateToYMD(Date) => return 2018/9/5
 * DateToYMD(Date, '-') => return 2018-9-5
 * @see {@link { https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Deprecated_toLocaleFormat }}
 */
export const DateToYMD = (date, separator = '/') => {
  const day = date.getDate();
  const month = date.getMonth() + 1; // month js object start from 0-11, but raspi start from 1-12
  const year = date.getFullYear();
  return `${year}${separator}${month}${separator}${day}`;
};

/**
 * Parse Date into Hour, Minute, and Second
 * @param {Date} date
 * @returns {String}
 * @example
 * DateToYMD(Date) => return 13:55:55
 * @see {@link { https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleTimeString }}
 */
export const DateToHMS = (date) => date.toLocaleTimeString('it-IT');

/**
 * @param {String} stringDate
 * @returns {Date}
 */
export const ParseToDate = (stringDate) => new Date(stringDate);

/**
 * @param {Date} date
 * @returns {String}
 * @example
 * DateToString(Date) => return 09/20/2021
 * @see {@link { https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString }}
 */
export const DateToString = (date) =>
  date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

/**
 * @param {Number} totalMinuteInSeconds
 * @param {Number} timeElapsed
 * @returns {String}
 * @example
 * TimeRemaining(60, 30) => 00 minutes 30 seconds
 */
export const TimeRemaining = (totalTimeInSecond, elapsedInSecond) => {
  let result = totalTimeInSecond - elapsedInSecond;
  if (result < 0) result = 0;
  return SecondToStringFormat(result);
};

/**
 * @param {Number} time
 * @returns {String}
 * @example
 * SecondToStringFormat(60) => 01 minutes 00 seconds
 */
export const SecondToStringFormat = (time) => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time - minutes * 60);
  return `${pad(minutes.toString(), 2)} Minutes ${pad(seconds.toString(), 2)} Seconds`;
};

export const getDateTime = (date, time) => new Date(`${date}T${time}:00`);

// Format the date (MM/DD/YYYY)
export const getFormattedDate = (date = new Date()) => {
  // date.toISOString().slice(0, 10); // '2024-09-27';
  const month = String(date.getMonth() + 1).padStart(2, '0'); // '09' (Months are 0-indexed, so add 1)
  const day = String(date.getDate()).padStart(2, '0'); // '27'
  const year = date.getFullYear(); // '2024'
  return normalizeDateFormat({day, month, year}); // '09/27/2024'
};

// Format the time (hh:mm)
export const getFormattedTime = (date = new Date()) => {
  const hours = String(date.getHours()).padStart(2, '0'); // '14'
  const minutes = String(date.getMinutes()).padStart(2, '0'); // '08'
  return `${hours}:${minutes}`; // '14:08'
};

// (MM/DD/YYYY)
export function normalizeDate(dateString, delimiter = '/') {
  // Split the date string into parts
  const [month, day, year] = dateString.split(delimiter).map(Number);

  // Create a Date object starting with a valid date
  const dateObj = new Date(year, 0); // Start from January 1st of the given year

  // Add the months and days to the date object, JS automatically handles overflow
  dateObj.setMonth(month - 1); // Month is 0-indexed, so subtract 1
  dateObj.setDate(day); // JavaScript handles overflow in days as well

  return dateObj;
}

export function normalizeDateFormat({day, month, year}, delimiter = '/') {
  return [month, day, year].join(delimiter); // '09/27/2024'
}

export function isValidDate(date) {
  return date instanceof Date && !isNaN(date.getTime());
}

export function normalizeTime(dateString, delimiter = ':') {
  // Split the date string into parts
  const [hour, minutes] = dateString.split(delimiter).map(Number);

  // Create a Date object starting with a valid date
  const dateObj = new Date(); // Start from January 1st of the given year

  // Add the months and days to the date object, JS automatically handles overflow
  dateObj.setHours(hour);
  dateObj.setMinutes(minutes);

  return dateObj;
}
